export default __webpack_public_path__ + "static/media/servicio-7.10e5a7ef.webp";